import { render } from "./OrderList.vue?vue&type=template&id=784c0741&scoped=true"
import script from "./OrderList.vue?vue&type=script&lang=js"
export * from "./OrderList.vue?vue&type=script&lang=js"

import "./OrderList.vue?vue&type=style&index=0&id=784c0741&scoped=true&lang=css"
import "./OrderList.vue?vue&type=style&index=1&id=784c0741&lang=css"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-784c0741"]])

export default __exports__